import { useEffect, useRef, useState } from "react";

/**
 * Inbound HTML mail keeps its own colors (often black text on an assumed white page), so it is rendered on a light
 * canvas inside a sandboxed iframe instead of the dark app surface. No scripts run; links open in a new tab.
 */
export function HtmlBody({ html }: { html: string }) {
  const ref = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState(120);
  const doc = `<!doctype html><html><head><meta charset="utf-8"><base target="_blank"><style>
    html,body{margin:0;padding:0;background:#ffffff;color:#1f2328}
    body{padding:14px 16px;font:14px/1.55 -apple-system,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;word-break:break-word;overflow-wrap:anywhere}
    img{max-width:100%;height:auto} table{max-width:100%} a{color:#0a66e4} blockquote{border-left:2px solid #d0d7de;margin:8px 0;padding-left:10px;color:#57606a}
    pre{white-space:pre-wrap}
  </style></head><body>${html}</body></html>`;
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => { const h = el.contentDocument?.documentElement?.scrollHeight ?? el.contentDocument?.body?.scrollHeight; if (h && Math.abs(h - height) > 2) setHeight(Math.min(h + 2, 20000)); };
    el.addEventListener("load", measure);
    const t = window.setTimeout(measure, 300); // images and fonts settle after load
    const t2 = window.setTimeout(measure, 1500);
    return () => { el.removeEventListener("load", measure); window.clearTimeout(t); window.clearTimeout(t2); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doc]);
  return <iframe ref={ref} className="email-frame" title="Email" sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox" srcDoc={doc} style={{ height }} />;
}
